import { render, staticRenderFns } from "./FulfillmentsListComponent.vue?vue&type=template&id=797e1fa0&"
import script from "./FulfillmentsListComponent.vue?vue&type=script&lang=js&"
export * from "./FulfillmentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports